import { useContext, useState } from "react";
import NetworkError from "../../components/NetworkError";
import { config } from "../../constants/config";
import { useEffect } from "react";
import Preloader from "../../components/Preloader";
import { Link, useNavigate } from "react-router-dom";
import UserContext from "../../contexts/UserContext";
import Licence from "../../components/licences/licence";
import Search from "../../components/Search";
import PaginationSelect from "../../components/sPaginationSelect";



export default function Licences() {
    // states
    const { user, logoutUser } = useContext(UserContext);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [elementsList, setElementsList] = useState([]);

    const [isSearch, setIsSearch] = useState(false);
    const [chaine, setChaine] = useState('');
    const [nbpage, setNbpage] = useState(1);
    const [page, setPage] = useState(0);
    const [currentpage, setCurrentpage] = useState('');


    const getElementsList = async (p) => {
        setLoading(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.secure.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded);
        
        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/licenses?limit=${config.secure.limit}&page=${p + 1}`, requestOptions).then((response) => {

            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data);
                    if (data?.head) {
                        let clientarray = [];

                        clientarray = data?.body?.data;
                        setNbpage(data?.body?.pages);
                        
                        setElementsList(clientarray);

                        setLoading(false);
                    } else {
                        if (data?.body?.data?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            setError(true);
                            setLoading(false);
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                setError(true);
                setLoading(false);
            }

        }).catch((err) => {
            // console.log("error", err);
            setError(true);
            setLoading(false);
        });
    }

    const autoSearchElement = async (c) => {

        if ((c && !isSearch) || (c && isSearch)) {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
            myHeaders.append("token", config.secure.PUBLICKEY);
            myHeaders.append("apikey", user.token);
            myHeaders.append("cpte", user.code);
            myHeaders.append("prof", user.profil);
            myHeaders.append("conn", user.espace);

            var requestOptions = {
                method: 'GET',
                headers: myHeaders,
                // body: urlencoded,
                redirect: 'follow'
            };

            // console.log("data send", urlencoded);

            await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/licenses?crit=${c}`, requestOptions).then((response) => {

                if (response?.status === 200) {
                    response.json().then(async (data) => {
                        // console.log("resonse jsondecode", data);
                        if (data?.head) {
                            let clientarray = [];
    
                            clientarray = data?.body?.data;
                            setNbpage(data?.body?.pages);
                            
                            setElementsList(clientarray);

                        } else {
                            if (data?.body?.data?.msg === "expiredsession") {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                setError(true);
                            }
                            // setLoading(false);
                        }
                    });
                } else if (response?.status === 401) {
                    logoutUser();
                    navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                } else {
                    setError(true);
                    // setLoading(false);
                }
    
            }).catch((err) => {
                // console.log("error", err);
                setError(true);
                setLoading(false);
            });
        } else if (c !== "" && isSearch) {
            setIsSearch(false);
            getElementsList(page);
        } else {
            setIsSearch(false);
            getElementsList(page);
        }
    }


    // comportements
    useEffect(() => {
        getElementsList(page);
    }, []);

    useEffect(() => {
        const stimeout = setTimeout(() => {
            autoSearchElement(chaine);
        }, 1000);

        return () => clearTimeout(stimeout);
    }, [chaine]);



    // affichages
    return (
        <>
            {loading && <Preloader />}
            {!loading && error && <NetworkError />}
            {!loading && !error && <div className="container-fluid">
                <h1 className="h4 mb-4 font-weight-bold text_primary">Licences</h1>
                <div className="row">
                    <div className="col-md-2 mb-3">
                        <PaginationSelect nbpage={nbpage} getList={getElementsList} page={page} setPage={setPage} current={currentpage} setCurrent={setCurrentpage} />
                    </div>
                    <div className="col-md-10 mb-3">
                        <Search
                            chaine={chaine}
                            setChaine={setChaine}
                            // search={searchEmployee}
                            placeholder="Rechercher une licence..."
                        />
                    </div>
                    <div className="col-md-12">
                        <div className="card shadow mb-4">
                            <div className="card-header py-3">
                                <Link to="/new-licence" data-toggle="tooltip" title="Nouvelle licence" data-placement="left" className="btn-shadow ml-3 btn btn-primary btn-sm float-right">
                                    <i className="fa fa-plus mr-1"></i> <span>Nouvelle licence</span>
                                </Link>
                                <h6 className="m-0 ">Liste des licences</h6>
                            </div>
                            <div className="card-body">
                                <div className="table-responsive mb-3">
                                    <table className="mb-0 table table-bordered">
                                        <thead className="bg-primary">
                                            <tr className="bg-primary text-white">
                                                <th className="text-center">#</th>
                                                <th>Type de licence</th>
                                                <th>Client</th>
                                                <th>Date début</th>
                                                <th>Date fin</th>
                                                <th>Etat</th>
                                                <th>Date d'ajout</th>
                                                <th className="text-center">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {(elementsList.length === 0) && <tr style={{ borderStyle: "none" }}>
                                                <th colSpan={8} className="text-center">Aucune licence trouvée</th>
                                            </tr>}
                                            {
                                                (elementsList.length > 0) && elementsList?.map((item, index) => (
                                                    <Licence licence={item} position={(config.secure.limit * page) + index} key={index} />
                                                ))
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                {/* <Pagination table={"licence"} getList={getElementsList} page={page} setPage={setPage} /> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>}
        </>
    )

}